import { NotificationCode } from 'app/common/model/notification-code';

export class StudyNotificationArm {

    constructor(
        public studyNotificationArmId: number,
        public studySchemaEvent: NotificationCode
      ) {}
}
